export default class ValidationResult {
    constructor(props) {
        Object.assign(this, props);
    }
}
